import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createOwner,
  deleteOwner,
  getAllOwners,
  updateOwner,
  updateOwnerStatus,
} from "services/bailleurService";

export const fetchOwners = createAsyncThunk(
  "owner/fetchOwners",
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const data = await getAllOwners(page, limit);

      return data.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addOwner = createAsyncThunk(
  "owner/addOwner",
  async (ownerData, thunkAPI) => {
    try {
      const data = await createOwner(ownerData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const editOwner = createAsyncThunk(
  "owner/editOwner",
  async ({ id, ownerData }, thunkAPI) => {
    try {
      const data = await updateOwner(id, ownerData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const removeOwner = createAsyncThunk(
  "owner/removeOwner",
  async (id, thunkAPI) => {
    try {
      await deleteOwner(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateOwnerStatusThunk = createAsyncThunk(
  "owner/updateStatus",
  async ({ id, status }, thunkAPI) => {
    try {
      const response = await updateOwnerStatus(id, status);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  owners: [],
  total: 0,
  totalPages: 1,
  currentPage: 1,
  loading: false,
  error: null,
};

const ownerSlice = createSlice({
  name: "owner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchOwners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOwners.fulfilled, (state, action) => {
        state.loading = false;
        state.owners = action.payload.items || [];
        state.total = action.payload.totalItems || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.totalPages = action.payload.totalPages || 1;
      })

      .addCase(fetchOwners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add
      .addCase(addOwner.fulfilled, (state, action) => {
        state.owners.unshift(action.payload);
      })

      // Edit
      .addCase(editOwner.fulfilled, (state, action) => {
        state.owners = state.owners.map((owner) =>
          owner.id === action.payload.id ? action.payload : owner
        );
      })

      // Delete
      .addCase(removeOwner.fulfilled, (state, action) => {
        state.owners = state.owners.filter(
          (owner) => owner.id !== action.payload
        );
      })

      // Update Status
      .addCase(updateOwnerStatusThunk.fulfilled, (state, action) => {
        const index = state.owners.findIndex(
          (owner) => owner._id === action.payload._id
        );
        if (index !== -1) {
          state.owners[index] = action.payload;
        }
      });
  },
});

export default ownerSlice.reducer;
